import { render, staticRenderFns } from "./exp_Docs.vue?vue&type=template&id=8e8d2230"
import script from "./exp_Docs.vue?vue&type=script&lang=js"
export * from "./exp_Docs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports